import React, { useState, Component } from 'react';
import { Activity, ArrowRightLeft, AlertCircle, Settings2, Database, Zap, UserPlus, ChevronDown } from 'lucide-react';
interface ActivityItem {
  id: number;
  type: string;
  title: string;
  desc: string;
  time: string;
  icon: ComponentType<{
    className?: string;
  }>;
  color: string;
  bg: string;
  border: string;
}
const activities: ActivityItem[] = [{
  id: 1,
  type: 'routing',
  title: 'Large volume routed to Dominate',
  desc: '450 leads matched new FICO criteria',
  time: 'Just now',
  icon: ArrowRightLeft,
  color: 'text-indigo-400',
  bg: 'bg-indigo-400/10',
  border: 'border-indigo-400/20'
}, {
  id: 2,
  type: 'alert',
  title: 'Sync mismatch detected',
  desc: 'Rate Watch list variance exceeded 100',
  time: '5m ago',
  icon: AlertCircle,
  color: 'text-rose-400',
  bg: 'bg-rose-400/10',
  border: 'border-rose-400/20'
}, {
  id: 3,
  type: 'system',
  title: 'Criteria updated',
  desc: 'J. Doe updated VA Cash Out rules',
  time: '12m ago',
  icon: Settings2,
  color: 'text-slate-400',
  bg: 'bg-slate-400/10',
  border: 'border-slate-400/20'
}, {
  id: 4,
  type: 'sync',
  title: 'Global sync completed',
  desc: '142,894 records validated',
  time: '15m ago',
  icon: Database,
  color: 'text-emerald-400',
  bg: 'bg-emerald-400/10',
  border: 'border-emerald-400/20'
}, {
  id: 5,
  type: 'routing',
  title: 'List depleted: Low FICO',
  desc: 'Active leads dropped below 500 threshold',
  time: '1h ago',
  icon: Activity,
  color: 'text-amber-400',
  bg: 'bg-amber-400/10',
  border: 'border-amber-400/20'
}, {
  id: 6,
  type: 'spike',
  title: 'Inflow spike detected',
  desc: 'Rate Watch saw +340% vs hourly average',
  time: '1h ago',
  icon: Zap,
  color: 'text-amber-400',
  bg: 'bg-amber-400/10',
  border: 'border-amber-400/20'
}, {
  id: 7,
  type: 'routing',
  title: 'Leads entered Shark Tank',
  desc: '+87 high-value leads added',
  time: '2h ago',
  icon: UserPlus,
  color: 'text-emerald-400',
  bg: 'bg-emerald-400/10',
  border: 'border-emerald-400/20'
}, {
  id: 8,
  type: 'system',
  title: 'Routing exception cleared',
  desc: 'Manual review by S. Chen on 23 leads',
  time: '3h ago',
  icon: Settings2,
  color: 'text-slate-400',
  bg: 'bg-slate-400/10',
  border: 'border-slate-400/20'
}, {
  id: 9,
  type: 'sync',
  title: 'Five9 connection re-established',
  desc: 'After 12s latency spike',
  time: '4h ago',
  icon: Database,
  color: 'text-sky-400',
  bg: 'bg-sky-400/10',
  border: 'border-sky-400/20'
}, {
  id: 10,
  type: 'routing',
  title: 'Leads exited Dominate',
  desc: '120 leads qualified out (closed-won)',
  time: '5h ago',
  icon: ArrowRightLeft,
  color: 'text-indigo-400',
  bg: 'bg-indigo-400/10',
  border: 'border-indigo-400/20'
}];
const COLLAPSED_COUNT = 5;
export function ActivityFeed() {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? activities : activities.slice(0, COLLAPSED_COUNT);
  return <div className="bg-slate-900/80 border border-slate-800/60 rounded-xl p-5 flex flex-col h-full" data-id="element-1">
      <div className="flex items-center justify-between mb-6" data-id="element-2">
        <div className="flex items-center gap-2" data-id="element-3">
          <div className="p-2 bg-slate-800 rounded-lg" data-id="element-4">
            <Activity className="w-5 h-5 text-slate-300" data-id="element-5" />
          </div>
          <div data-id="element-6">
            <h2 className="text-lg font-semibold text-white" data-id="element-7">Live Activity</h2>
            <p className="text-sm text-slate-400" data-id="element-8">Operational events feed</p>
          </div>
        </div>
        <span className="relative flex h-2.5 w-2.5" aria-label="Live" data-id="element-9">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-10"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" data-id="element-11"></span>
        </span>
      </div>

      <div className="flex-1 overflow-y-auto pr-2 -mr-2" data-id="element-12">
        <div className="space-y-0" data-id="element-13">
          {visible.map((item, idx) => {
          const isLast = idx === visible.length - 1;
          return <div key={item.id} className="flex gap-3 group" data-id="element-14">
                <div className="relative flex flex-col items-center" data-id="element-15">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center border ${item.bg} ${item.border} shrink-0 z-10`} data-id="element-16">
                    <item.icon className={`w-4 h-4 ${item.color}`} data-id="element-17" />
                  </div>
                  {!isLast && <div className="w-px flex-1 bg-slate-800/60 group-hover:bg-slate-700 transition-colors" data-id="element-18"></div>}
                </div>
                <div className="pb-4 flex-1 min-w-0" data-id="element-19">
                  <div className="flex items-baseline justify-between gap-4" data-id="element-20">
                    <h4 className="text-sm font-medium text-slate-200 truncate" data-id="element-21">
                      {item.title}
                    </h4>
                    <span className="text-xs text-slate-500 whitespace-nowrap" data-id="element-22">
                      {item.time}
                    </span>
                  </div>
                  <p className="text-sm text-slate-400 mt-0.5" data-id="element-23">{item.desc}</p>
                </div>
              </div>;
        })}
        </div>
      </div>

      <div className="mt-2 pt-4 border-t border-slate-800/60" data-id="element-24">
        <button onClick={() => setExpanded(v => !v)} className="w-full flex items-center justify-center gap-1.5 text-sm text-indigo-400 hover:text-indigo-300 font-medium transition-colors" data-id="element-25">
          {expanded ? 'Show Less' : `View Full Log (${activities.length - COLLAPSED_COUNT} more)`}
          <ChevronDown className={`w-4 h-4 transition-transform ${expanded ? 'rotate-180' : ''}`} data-id="element-26" />
        </button>
      </div>
    </div>;
}